
import { useEffect } from 'react';

const SubtleInteractions = () => {
  useEffect(() => {
    // Add hover effects to navigation links
    const navLinks = document.querySelectorAll('.nav-link');
    navLinks.forEach(link => {
      link.addEventListener('mouseenter', () => {
        link.classList.add('animate-pulse-slow');
      });
      link.addEventListener('mouseleave', () => {
        link.classList.remove('animate-pulse-slow');
      });
    });

    // Add hover effects to cards
    const cards = document.querySelectorAll('.card-project, .card');
    cards.forEach(card => {
      card.addEventListener('mouseenter', () => {
        card.classList.add('hover-lift');
      });
      card.addEventListener('mouseleave', () => {
        card.classList.remove('hover-lift');
      });
    });

    // Add scroll reveal animations to sections
    const observeElements = () => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });

      document.querySelectorAll('.section-container').forEach(section => {
        observer.observe(section);
        section.classList.add('reveal-section');
      });
    };

    observeElements();

    // Add cursor interaction on buttons
    const buttons = document.querySelectorAll('button, a.btn');
    buttons.forEach(button => {
      button.addEventListener('mouseenter', () => {
        document.body.style.cursor = 'pointer';
      });
      button.addEventListener('mouseleave', () => {
        document.body.style.cursor = 'default';
      });
    });

    // Cleanup event listeners on unmount
    return () => {
      navLinks.forEach(link => {
        link.removeEventListener('mouseenter', () => {});
        link.removeEventListener('mouseleave', () => {});
      });
      
      cards.forEach(card => {
        card.removeEventListener('mouseenter', () => {});
        card.removeEventListener('mouseleave', () => {});
      });
      
      buttons.forEach(button => {
        button.removeEventListener('mouseenter', () => {});
        button.removeEventListener('mouseleave', () => {});
      });
    };
  }, []);

  return null; // This component doesn't render anything
};

export default SubtleInteractions;
